import { Checkbox as CheckboxPrimitive, type CheckboxRootProps } from "@base-ui/react/checkbox"
import React from "react"

import cn from "#Utils/cn"

export type CheckboxProps = CheckboxRootProps & {
  className?: string
  children?: React.ReactNode
}

export default function Checkbox({ className, indeterminate, ...props }: CheckboxProps) {
  return (
    <label className={cn("c-formv2__checkbox", className)}>
      <CheckboxPrimitive.Root
        className="c-formv2__checkbox__input"
        indeterminate={indeterminate}
        {...props}
      >
        <CheckboxPrimitive.Indicator className="c-formv2__checkbox__indicator" keepMounted>
          {indeterminate ? (
            <span className="w-2 h-0.5 bg-current rounded" />
          ) : (
            <CheckIcon className="size-2" />
          )}
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {props.children && <div className="c-formv2__checkbox__label">{props.children}</div>}
    </label>
  )
}

function CheckIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" {...props}>
      <path
        d="M0.75 2.75L2.75 4.75L6.75 0.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
